import React, { useEffect, useContext, useState, Fragment, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import DataContext from '../../data/DataContext';
import MsgRetry from '../../../asset/img/btn_refresh_nor.svg';
// import MsgRetryPressed from '../../../asset/img/btn_refresh_pre.png';
import MsgDelete from '../../../asset/img/btn_remove_nor.svg';
// import MsgDeletePressed from '../../../asset/img/btn_remove_pre.png';
import LeftTail from '../../../asset/img/bubble_point1.png';
import RightTail from '../../../asset/img/bubble_point2.png';
import TypingData from '../../../asset/img/img_text_loading.json';
import Lottie from 'lottie-react';
// import moment from "moment";

const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.0313rem',
    whiteSpace: 'pre-wrap',
    zIndex: 10,
    // outline: 0,
  },
  leftContainer: {
    justifyContent: 'flex-start',
    margin: '0rem 0rem 0.375rem 0rem',
  },
  rightContainer: {
    justifyContent: 'flex-end',
    margin: '0.125rem 0rem 0rem 0rem',
    alignItems: 'center',
  },
  message: {
    flexWrap: 'wrap',
    color: theme.color.message.color,
    width: '16.25rem',
    zIndex: 10,
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
  leftMessage: {
    padding: '0.5625rem 1.25rem',
    margin: '0rem 0.375rem 0rem 1rem',
    borderRadius: '0.75rem',
    backgroundColor: theme.color.message.background,
    // boxShadow: "0px 12px 12px rgba(194, 194, 194, 0.58)",
    // fontWeight: "300",
    'text-size-adjust': 'auto',
    fontSize: theme.font.size14, // "14px",
  },
  rightMessage: {
    padding: '0',
    fontSize: theme.font.size16, // "16px",
    margin: '0rem 1rem 0rem 0.375rem',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    fontWeight: 'bold',
    lineHeight: 1.38,
    textAlign: 'right',
    letterSpacing: 'normal',
  },
  date: {
    color: theme.color.message.date,
    fontSize: theme.font.size11,
    fontWeight: '300',
    alignSelf: 'flex-end',
    margin: '0.3125rem 0 0.375rem 0',
    textAlign: 'center',
  },
  rightDate: {
    margin: '0.3125rem 0 1.375rem 0',
  },
  typing: {
    width: '1.875rem',
    height: '0.375rem',
  },
  leftTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid #fff',
    // borderRadius: '5px',
    zIndex: 11,
    margin: '0.375rem -1.3125rem 0rem 0.6875rem',
    backgroundImage: `url(${LeftTail})`,
    backgroundSize: '1.3125rem 0.75rem',
    width: '1.3125rem',
    height: '0.75rem',
    minWidth: '1.3125rem',
  },
  rightTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid ' + theme.color.message.background,
    // borderRadius: '5px',
    zIndex: 11,
    margin: '1.625rem 0.6875rem 0rem -1.3125rem',
    backgroundImage: `url(${RightTail})`,
    backgroundSize: '1.3125rem 0.75rem',
    width: '1.3125rem',
    height: '0.75rem',
    minWidth: '1.3125rem',
  },
  leftBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  rightLoadingBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // margin: "10px 6px 26px 9px"
  },
  messageLoading: {
    // width: "3.125em",
    // height: "1.375rem",
    width: '5rem',
    height: '2.5rem',
    cursor: 'pointer',
    // backgroundSize: "50px 20px"
  },
  messageStatusImg: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    //margin: "10px 0 0 0",
    border: 'none',
    // outline: '0 none',
    backgroundColor: 'transparent',
    backgroundSize: '1.5rem',
    backgroundImage: `url(${MsgRetry})`,
    // "&:active": {
    //   backgroundImage: `url(${MsgRetryPressed})`,
    // }
  },
  rightBox: {
    position: 'relative',
  },
  btnDelete: {
    position: 'absolute',
    left: '-1.5625rem',
    top: '0.75rem',
    width: '2rem',
    height: '2rem',
    zIndex: '20',
    cursor: 'pointer',
    border: 'none',
    // outline: '0 none',
    backgroundColor: 'transparent',
    backgroundSize: '2rem',
    backgroundImage: `url(${MsgDelete})`,
    // "&:active": {
    //   backgroundImage: `url(${MsgDeletePressed})`,
    // }
  },
  '@media screen and (max-width:767px)': {
    message: {
      width: '100%',
    },
    leftMessage: {
      margin: '0rem 1rem',
    },
  },
});

const lottieTypingOptions = {
  loop: true,
  autoplay: true,
  animationData: TypingData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function TXLeftRaw(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const loading = data.loading;
  return (
    (data.text || loading) && (
      <div
        className={[classes.root, classes.leftContainer].join(' ')}
        role={'text'}
        aria-label={`${context.string.aria.chatbotMessage} ${data.text.replace(
          /(\r\n|\n|\r)/gm,
          ' '
        )}`} /*, ${moment(data.date, "LT").format("A hh시 mm분")}`}*/
        tabIndex={0}
      >
        {/* <div className={classes.leftTail}/> */}
        {loading ? (
          <Lottie
            {...lottieTypingOptions}
            className={classes.messageLoading}
            width={'3.125em'}
            height={'1.375em'}
          />
        ) : (
          <div className={[classes.message, classes.leftMessage].join(' ')} tabIndex={0}>
            {data.text.split('\n').map((content, index) => (
              <Fragment key={index}>
                <span>{content}</span>
                <br />
              </Fragment>
            ))}
          </div>
        )}
        {/* {!loading && <p className={classes.date} aria-label={`${moment(data.date, "LT").format("A hh시 mm분")}`}>{data.date}</p>} */}
      </div>
    )
  );
}

function TXRightRaw(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const [loading, setLoading] = useState(data.loading);
  const [online, setOnline] = useState(data.online);
  const [focused, setFocused] = useState(true);
  const ref = useRef(null);
  const handleRetry = async () => {
    setLoading(true);
    setOnline(true);
    if (data.action) {
      await data.action(context, (isOnline) => {
        setLoading(false);
        setOnline(isOnline);
      });
      return;
    }
    setTimeout(() => {
      setLoading(false);

      let deleteMsgs = [data.id];
      if (data.dateMsgId) {
        deleteMsgs.push(data.dateMsgId);
      }
      context.deleteMessage(deleteMsgs);
      context.request(context, data.text, 'text');
    }, 2000);
  };
  // const handleDelete = () => {
  //   context.deleteMessage([data.id]);
  // }

  useEffect(() => {
    if (!ref.current) {
      console.log(
        `[TX] Fail to call focus() - ref.current is null - when TX text "${data.text}"`
      );
    } else {
      console.log(`[TX] Succeed to call focus() when TX text "${data.text}"`);
    }
    if (ref.current && !data.isOld && focused) {
      ref.current.focus();
      console.log('[Focus Order] TX', ref.current);
      setFocused(false);
    }
    if (data.isOld) {
      setFocused(false);
    }
  }, []);
  // if (ref && ref.current && ref.current.focus && focused) {
  //   ref.current.focus();
  //   console.log("[Focus Order] TX", ref.current);
  //   setFocused(false);
  // }

  const textSplit = data.text ? data.text.trim().split('\n') : [];

  return (
    textSplit.length > 0 && (
      <div
        className={[classes.root, classes.rightContainer].join(' ')}
        role={'text'}
        tabIndex={0}
        aria-label={`${context.string.aria.myMessage} ${data.text}`} /*, ${moment(data.date, "LT").format("A hh시 mm분")}`}*/
        ref={ref}
      >
        {loading ? (
          <div className={classes.rightLoadingBox}>
            <Lottie
              {...lottieTypingOptions}
              className={classes.messageLoading}
              width={32}
              height={14}
            />
          </div>
        ) : (
          <>
            <div className={classes.leftBox}>
              {!online && (
                <button
                  type="button"
                  className={classes.messageStatusImg}
                  onClick={handleRetry}
                />
              )}
              {/* <p className={[classes.date, classes.rightDate].join(' ')} aria-label={`${moment(data.date, "LT").format("A hh시 mm분")}`}>{data.date}</p> */}
            </div>
            <span className={[classes.message, classes.rightMessage].join(' ')}>
              {textSplit.map(
                (content, index) =>
                  content.trim() && (
                    <Fragment key={index}>
                      <span>
                        {index === 0 && `"`} {content.trim()}{' '}
                        {index === textSplit.length - 1 && `"`}
                      </span>
                      <br />
                    </Fragment>
                  )
              )}
            </span>
            {/* {!online&&(
          <div className={classes.rightBox}>
            <button type="button" className={classes.btnDelete} onClick={handleDelete}/>
          </div>
        )} */}
            {/* <div className={classes.rightTail} /> */}
          </>
        )}
      </div>
    )
  );
}
const TXRight = withStyles(styles)(TXRightRaw);
const TXLeft = withStyles(styles)(TXLeftRaw);

function TX(props) {
  const { data } = props;
  return data.mine ? <TXRight data={data} /> : <TXLeft data={data} />;
}
export default withStyles(styles)(TX);
